import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { Button, Table } from 'react-bootstrap';
import { FaEdit, FaTimesCircle } from 'react-icons/fa';
import {MenuMaster} from "../../../models/config/MenuMaster";

export type MenuMasterTableProps = {
    menus?: MenuMaster[];
    isPending?: boolean;
    onEdit?: (menuMasters: MenuMaster[]) => void;
    onDelete?: (menuMasters: MenuMaster[]) => void;
};

export const MenuMasterTable = (
    props: MenuMasterTableProps
) => {
    const { isPending, menus, onEdit, onDelete } = props;

    const menuGroups = useMemo(() => {
        if (!menus) {
            return undefined;
        }

        const output = new Map<string, MenuMaster[]>();
        menus.forEach(menu => {
            if (!output.has(menu.id)) {
                output.set(menu.id, []);
            }
            output.get(menu.id)!.push(menu);
        });

        return Array.from(output);
    }, [menus]);

    return (
        <div className="overflow-auto">
            <Table
                className="table-bordered align-middle"
                size="sm"
            >
                <thead>
                <tr className="table-active thead-light w-full text-center">
                    <th />
                    <th className="nowrap">Menu ID</th>
                    <th className="nowrap">Menu Name</th>
                    <th className="nowrap">Created On</th>
                    <th className="nowrap">Created By</th>
                    <th className="nowrap">Updated On</th>
                    <th className="nowrap">Updated By</th>
                </tr>
                </thead>
                <tbody>
                {isPending ? (
                    <tr>
                        <td colSpan={7}>
                            <div className="flex items-center justify-center">
                                <div className="spinner-border text-primary my-2" />
                            </div>
                        </td>
                    </tr>
                ) : (
                    menuGroups?.map(([menuId, menus]) => {
                        const menu = menus[0] ?? {};

                        const formattedCreatedOn = menu.created_on
                            ? dayjs(
                                menu.created_on,
                                'YYYYMMDDHHmmss'
                            ).format('DD/MM/YYYY HH:mm น.')
                            : undefined;

                        const formattedUpdatedOn = menu.updated_on
                            ? dayjs(
                                menu.updated_on,
                                'YYYYMMDDHHmmss'
                            ).format('DD/MM/YYYY HH:mm น.')
                            : undefined;

                        return (
                            <tr key={menuId}>
                                <td className="whitespace-nowrap align-middle">
                                    <Button
                                        size="sm"
                                        variant="outline-info"
                                        onClick={() => onEdit?.(menus)}
                                    >
                                        <FaEdit />
                                    </Button>
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        className="ml-1"
                                        onClick={() => onDelete?.(menus)}
                                    >
                                        <FaTimesCircle />
                                    </Button>
                                </td>
                                <td className="whitespace-nowrap align-middle">
                                    {menu.id}
                                </td>
                                <td className="align-middle">
                                    {menu.menu_name}
                                </td>
                                <td className="align-middle">
                                    {formattedCreatedOn}
                                </td>
                                <td className="align-middle">
                                    {menu.created_by}
                                </td>
                                <td className="align-middle">
                                    {formattedUpdatedOn}
                                </td>
                                <td className="align-middle">
                                    {menu.updated_by}
                                </td>
                            </tr>
                        );
                    })
                )}
                </tbody>
            </Table>
        </div>
    );
};
